function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import DesktopContentComponent from "./desktop-content/desktop-content-component";
import MobileAssetContentComponent from "/components/core/one-pager/mobile-asset-content/mobile-asset-content-component";
import MobileBackgroundGifContentComponent from "/components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component";
import SocialProofComponent from "components/segments/social-proof/social-proof-component";
import ShortFooterComponent from "components/segments/short-footer/short-footer-component";
import { MOBILE_VERSIONS } from "/constants/one-pager-asset-types";
import { StyledOnePagerAssetContentComponent } from "./one-pager-asset-content-component.scss";
class OnePagerAssetContentComponent extends PureComponent {
    getMobileVersion() {
        const { mobileVersion } = this.props;
        if (mobileVersion === MOBILE_VERSIONS.MOBILE_ASSET) {
            return MobileAssetContentComponent;
        }
        return MobileBackgroundGifContentComponent;
    }
    render() {
        const { SocialProof, ShortFooter } = this.props;
        const { showSocialProof, content: socialProofContent } = SocialProof;
        const { showShortFooter, content: shortFooterContent } = ShortFooter;
        const MobileComponent = this.getMobileVersion();
        const hasMultipleFolds = showSocialProof || showShortFooter;
        return /*#__PURE__*/ _jsxs(StyledOnePagerAssetContentComponent, {
            className: classnames("one-pager-asset-content-component", {
                "multiple-folds": hasMultipleFolds
            }),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "desktop-content-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(DesktopContentComponent, _object_spread({}, this.props)),
                        showSocialProof && /*#__PURE__*/ _jsx(SocialProofComponent, _object_spread({}, socialProofContent)),
                        showShortFooter && /*#__PURE__*/ _jsx(ShortFooterComponent, _object_spread({}, shortFooterContent))
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-content-wrapper",
                    children: /*#__PURE__*/ _jsx(MobileComponent, _object_spread({}, this.props))
                })
            ]
        });
    }
}
export { OnePagerAssetContentComponent as default };
OnePagerAssetContentComponent.defaultProps = {
    assetPart: {},
    textPart: {},
    collaborationWith: {},
    mobileVersion: MOBILE_VERSIONS.MOBILE_BACKGROUND_GIF,
    SocialProof: {},
    ShortFooter: {}
};
